import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { NavLink, useLocation } from "react-router-dom";
import {
	AppBar,
	Box,
	Menu,
	MenuItem,
	Avatar,
	Tooltip,
	Typography,
	IconButton,
	Drawer,
	List,
	ListItem,
	ListItemText,
	useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../../Redux/UserDetails";
import { BASE_API_URL } from "../../utils/constants";
import WelcomeName from "./WelcomeName";
import MyProfile from '../../Pages/MyProfile/MyProfile';
import MyPhoto from "../../Pages/ProfileImageFn";


const IgniteAdmins = [
	"h.srinivasan",
	"varsha.a.tyagi",
	"uma.rani.battu",
	"ankur.e.mishra",
	"arpita.m.singh",
	"aluru.akash",
	"nikita.apte",
	"srikanth.narabathoju",
	"sindhu.s.nambiar",
	"mohana.krishnaveni",
	"n.sharda",
	"jeevan.shetty"
];

function Header() {
	const [anchorEl, setAnchorEl] = useState(null);
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [activeTab, setActiveTab] = useState("home");
	const { instance } = useMsal();
	const [temp, setTemp] = useState(false);
	const [autoOpened, setAutoOpened] = useState(false);
	const location = useLocation();

	const { pathname, search, hash } = useLocation();

	const dispatch = useDispatch();
	const userData = useSelector((state) => state.userDetails.userData[0]);
	const isDesktop = useMediaQuery("(min-width:1024px)");
	const open = Boolean(anchorEl);

	const handleClick = (event) => setAnchorEl(event.currentTarget);
	const handleClose = () => setAnchorEl(null);

	const activeAccount = instance.getActiveAccount();
	let loggedInEnterpriseId = "";
	if (activeAccount)
		loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

	useEffect(() => {
		const tabFromPath = pathname.split("/")[1];
		if (tabFromPath) {
			setActiveTab(tabFromPath);
		}
	}, [pathname]);

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		});
	}, [pathname]);

	useEffect(() => {
		dispatch(getUserData(loggedInEnterpriseId));
	}, [loggedInEnterpriseId]);

	const profileImage =
		userData?.photo
			? `${BASE_API_URL}/${userData?.photo}`
			: null;

	const normalizedUserId = loggedInEnterpriseId?.toLowerCase();
	const isAdmin = IgniteAdmins.includes(normalizedUserId);


	const navItems = [
		{ label: "Home", path: "/home", tab: "home" },
		{ label: "Learning Hubs", path: "/learningHubs", tab: "learningHubs" },
		{ label: "Dashboard", path: "/dashboard", tab: "dashboard" },
		{ label: "Ignite Talks", path: "/igniteTalks", tab: "igniteTalks" },
		{ label: "Hall of Fame", path: "/hallOfFame", tab: "hallOfFame" },
		{ label: "About Ignite", path: "/aboutIgnite", tab: "aboutIgnite" },
		{ label: "Team", path: "/team", tab: "team" },
		{ label: "FAQ", path: "/faq", tab: "faq" },
		...(isAdmin
			? [{ label: "Admin", path: "/admin", tab: "admin" }]
			: []),
	];

	const isEmpty = (value) =>
		value === null ||
		value === undefined ||
		value === "" ||
		(Array.isArray(value) && value.length === 0);

	const isProfileIncomplete =
		userData &&
		(
			isEmpty(userData?.capability) ||
			isEmpty(userData?.industry) ||
			isEmpty(userData?.category) ||
			isEmpty(userData?.role)
		);

	useEffect(() => {
		if (!userData) return;

		if (autoOpened) return;

		if (isProfileIncomplete) {
			const avatarElement = document.querySelector(".profile-avatar");

			if (avatarElement) {
				setAnchorEl(avatarElement);
				setAutoOpened(true);
			}
		}
	}, [userData, isProfileIncomplete, autoOpened]);

	return (
		<>
			<AppBar
				position="sticky"
				elevation={0}
				sx={{
					top: 0,
					zIndex: 1100,
					px: isDesktop ? "3rem" : "1.5rem",
					py: isDesktop ? "1rem" : "0.5rem",
					backgroundColor: "#200226",
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					width: "100%"
				}}
			>
				<Box>
					<NavLink
						to="/home"
						style={{
							textDecoration: "none",
							background: "transparent",
							border: "none",
						}}
						onClick={() => setActiveTab("home")}
					>
						<img src="Assets/igniteLogo.png" alt="logo" style={{ height: 30 }} />
					</NavLink>
				</Box>

				{isDesktop && (
					<Box sx={{ display: "flex", gap: 4, mx: "auto" }}>
						{navItems.map((item) => (
							<Box
								key={item.tab}
								onClick={() => setActiveTab(item.tab)}
								sx={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									cursor: "pointer",
								}}
							>
								<NavLink
									to={item.path}
									style={{
										textDecoration: "none",
										background: "transparent",
										border: "none",
									}}
								>
									<Typography
										sx={{
											marginTop: "5px",
											fontFamily: "Graphik",
											fontSize: "12px",
											color: "#FFFFFF",
											fontWeight:
												activeTab === item.tab ? 500 : 400,
										}}
									>
										{item.label}
									</Typography>

									<Box
										sx={{
											mt: "2px",
											height: "1.5px",
											width: "60%",
											borderRadius: "2px",
											backgroundColor:
												activeTab === item.tab ? "#FFFFFF" : "transparent",
											transition: "all 0.3s ease",
										}}
									/>
								</NavLink>
							</Box>
						))}
					</Box>
				)}

				{/* RIGHT SECTION */}
				<Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: "auto" }}>
					<Tooltip title="Account settings">
						<MyPhoto
							profileImage={profileImage}
							handleClick={handleClick}
						/>
					</Tooltip>
					<WelcomeName />

					{!isDesktop && (
						<IconButton
							sx={{ color: "#fff" }}
							onClick={() => setDrawerOpen(true)}
						>
							<MenuIcon />
						</IconButton>
					)}
				</Box>
				{/* PROFILE MENU */}
				<Menu
					anchorEl={anchorEl}
					open={open}

					onClose={handleClose}
					anchorOrigin={{ horizontal: "right", vertical: "bottom" }}

					transformOrigin={{
						vertical: "top",
						horizontal: "right",
					}}
					PaperProps={{
						sx: {
							width: "25em",
							maxWidth: "25em",
							borderRadius: "0px",
							mt: "2em",
							overflow: "visible",

							background: "linear-gradient(135deg, #f5f7fa 0%, #e4ebf5 100%)",
							maxHeight: "80vh",
							overflowY: "auto",
							overflowX: "hidden",
							scrollbarWidth: "thin",
							"&::-webkit-scrollbar": {
								width: "4px"
							},
							"&::-webkit-scrollbar-thumb": {
								backgroundColor: "#bbb",
								borderRadius: "4px",
							},
							"&::before": {
								content: '""',
								position: "absolute",
								top: "-8px",
								width: "16px",
								height: "16px",
								background: "linear-gradient(135deg, #f5f7fa 0%, #e4ebf5 100%);",
								transform: "rotate(45deg)",
								boxShadow: "-2px -2px 6px rgba(0,0,0,0.08)",
								zIndex: 1,
							},
						},
					}}

				>
					<Box
						sx={{
							fontSize: '0.8em',
							background: 'linear-gradient(135deg, #f5f7fa 0%, #e4ebf5 100%);'

						}}
					>
						<div className="myprofile-extra-box">
							<MyProfile onClose={handleClose} />
						</div>
					</Box>
				</Menu>
			</AppBar>

			{/* MOBILE DRAWER */}
			<Drawer
				anchor="right"
				open={drawerOpen}
				onClose={() => setDrawerOpen(false)}
			>
				<Box sx={{ width: 250, p: 2 }}>
					<List>
						{navItems.map((item) => (
							<ListItem
								button
								key={item.tab}
								component={NavLink}
								to={item.path}
								onClick={() => {
									setActiveTab(item.tab);
									setDrawerOpen(false);
								}}
								sx={{ color: "#200226" }}
							>
								<ListItemText
									primary={item.label}
									sx={{
										textDecoration:
											activeTab === item.tab ? "underline" : "none",
									}}
								/>
							</ListItem>
						))}
					</List>
				</Box>
			</Drawer>
		</>
	);
}

export default Header;
